exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".image {\n  width: 100%; }\n\ntable {\n  width: 100%; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/Administrator/Desktop/Hotel-Data/src/app/user/user.scss
// module id = ../../../../../src/app/user/user.scss
// module chunks = main